import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PerfilUsuarioComponent } from './perfil-usuario.component';
import { RouterModule } from '../../../../../node_modules/@angular/router';
import { SharedModule } from '../../../core/modules/shared.module';
import { CambiarPasswordComponent } from './cambiar-password/cambiar-password.component';

const routes = [
    {
        path     : 'perfil',
        component: PerfilUsuarioComponent
    },
     {
        path     : 'perfil/cambiarPassword',
        component: CambiarPasswordComponent
    },
   /* {
        path     : 'clientes/editar/:idCliente',
        component: ClientesEditarComponent
    } */
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
      PerfilUsuarioComponent,
      CambiarPasswordComponent
]
})
export class PerfilUsuarioModule { }



// WEBPACK FOOTER //
// ./src/app/main/content/perfil-usuario/perfil-usuario.module.ts